import { useState } from 'react';
import HeadingTextSolid from '@simplywallst/ui-core/icons/HeadingTextSolid';
import { ToggleButton } from '@simplywallst/ui-core';
import { isDisabled } from '@components/RichTextEditor/utils';
import type { FormatType } from '../../useRichTextEditor';
import { cn } from '@simplywallst/ui-core/next';

interface Props {
  format: (formatType: FormatType) => void;
  isActive: (formatType: FormatType) => boolean | undefined;
  onOpen: (items: number) => void;
  onClose: () => void;
}

const HEADINGS = [1, 2, 3];

export const Heading = ({ format, isActive, onOpen, onClose }: Props) => {
  const [showingPanel, setShowingPanel] = useState(false);

  const isButtonActive =
    showingPanel ||
    isActive('heading1') ||
    isActive('heading2') ||
    isActive('heading3');

  const isButtonDisabled = isDisabled(
    ['bulletList', 'orderedList', 'image'],
    isActive
  );

  return (
    <>
      <ToggleButton
        aria-label="Toggle heading panel"
        styleType="subtle"
        onClick={() => {
          setShowingPanel(!showingPanel);
          if (showingPanel) {
            onClose();
          } else {
            onOpen(3);
          }
        }}
        disabled={isButtonDisabled}
        state={isButtonActive ? 'on' : 'off'}
        aria-pressed={isButtonActive}
      >
        <HeadingTextSolid
          className={cn(showingPanel && '!fill-accent !opacity-100')}
        />
      </ToggleButton>
      {showingPanel && (
        <>
          {HEADINGS.map((item) => (
            <ToggleButton
              key={`heading${item}`}
              styleType="subtle"
              onClick={() => format(`heading${item}` as FormatType)}
              state={isActive(`heading${item}` as FormatType) ? 'on' : 'off'}
              aria-pressed={isActive(`heading${item}` as FormatType)}
              className="!text-xs !font-bold !text-softer"
              disabled={isButtonDisabled}
              aria-label={`Toggle heading ${item}`}
            >
              {`H${item}`}
            </ToggleButton>
          ))}
        </>
      )}
    </>
  );
};
